'use client';

import { Checkbox } from '@pickleballinc/react-ui';
import { useRouter, useSearchParams } from 'next/navigation';

export const ShowFreeAgentsOnlyCheckbox = () => {
	const searchParams = useSearchParams();
	const router = useRouter();
	const toggle = () => {
		const params = new URLSearchParams(searchParams.toString());

		if (searchParams?.get('show_free_agents')) {
			params.delete('show_free_agents');
		} else {
			params.set('show_free_agents', 'true');
		}

		params.set('current_page', '1');

		router.push(`?${params.toString()}`);
	};

	return (
		<Checkbox
			theme="orange"
			checked={searchParams?.get('show_free_agents') === 'true'}
			size="md"
			Text="Show free agents only"
			onChange={() => toggle()}
		/>
	);
};
